import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tributo'
})
export class TributoPipe implements PipeTransform {

  transform(tributo: any, args?: any): any {
    if (tributo) {
      tributo = tributo.replace(/[^0-9]+/g, '');

      if (tributo.length > 11) {
        tributo = tributo.substring(0, 11) + ' ' + tributo.substring(11);
      }

      if (tributo.length > 13) {
        tributo = tributo.substring(0, 13) + ' ' + tributo.substring(13);
      }

      if (tributo.length > 25) {
        tributo = tributo.substring(0, 25) + ' ' + tributo.substring(25);
      }

      if (tributo.length > 27) {
        tributo = tributo.substring(0, 27) + ' ' + tributo.substring(27);
      }

      if (tributo.length > 39) {
        tributo = tributo.substring(0, 39) + ' ' + tributo.substring(39);
      }

      if (tributo.length > 41) {
        tributo = tributo.substring(0, 41) + ' ' + tributo.substring(41);
      }

      if (tributo.length > 53) {
        tributo = tributo.substring(0, 53) + ' ' + tributo.substring(53);
      }
    }
    return tributo;
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/tributo.pipe.ts